import { render, staticRenderFns } from "./VAuthorization.vue?vue&type=template&id=0c38ba90&scoped=true"
import script from "./VAuthorization.vue?vue&type=script&lang=js"
export * from "./VAuthorization.vue?vue&type=script&lang=js"
import style0 from "./VAuthorization.vue?vue&type=style&index=0&id=0c38ba90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c38ba90",
  null
  
)

export default component.exports